// badge images
import pandaBadgeImage from 'Assets/badging/Badge_Pal.png';
import bearBadgeImage from 'Assets/badging/Badge_Buddy.png';
import rabbitBadgeImage from 'Assets/badging/Badge_Ranger.png';
import tigerBadgeImage from 'Assets/badging/Badge_Titan.png';
import gorillaBadgeImage from 'Assets/badging/Badge_Guru.png';
import unicornBadgeImage from 'Assets/badging/Badge_Wizard.png';

// certificate images
import certPal from 'Assets/badging/Cert_Pal.jpg';
import certBuddy from 'Assets/badging/Cert_Buddy.jpg';
import certRanger from 'Assets/badging/Cert_Ranger.jpg';
import certTitan from 'Assets/badging/Cert_Titan.jpg';
import certGuru from 'Assets/badging/Cert_Guru.jpg';
import certWizard from 'Assets/badging/Cert_Wizard.jpg';

// monochrome certificate images
import bwCertPal from 'Assets/badging/BWCert_Pal.jpg';
import bwCertBuddy from 'Assets/badging/BWCert_Buddy.jpg';
import bwCertRanger from 'Assets/badging/BWCert_Ranger.jpg';
import bwCertTitan from 'Assets/badging/BWCert_Titan.jpg';
import bwCertGuru from 'Assets/badging/BWCert_Guru.jpg';
import bwCertWizard from 'Assets/badging/BWCert_Wizard.jpg';

export const REWARD_LEVEL = {
  PAL: "PAL",
  BUDDY: "BUDDY",
  RANGER: "RANGER",
  TITAN: "TITAN",
  GURU: "GURU",
  WIZARD: "WIZARD",
};

export const BADGE_TYPE = {
  NUM_SESSIONS: "NUM_SESSIONS",
  NUM_MINUTES: "NUM_MINUTES",
  NEW_WCPM_HIGH: "NEW_WCPM_HIGH",
  SKILLS_SCAFFOLD_GRADUATION: "SKILLS_SCAFFOLD_GRADUATION",
  NEW_HIGH: "NEW_HIGH",
  CUSTOM: "CUSTOM",
};

// The number of sessions that represents a badge level
export const REWARD_LEVEL_TO_NUM_SESSIONS = {
  [REWARD_LEVEL.PAL]: 5,
  [REWARD_LEVEL.BUDDY]: 10,
  [REWARD_LEVEL.RANGER]: 20,
  [REWARD_LEVEL.TITAN]: 50,
  [REWARD_LEVEL.GURU]: 75,
  [REWARD_LEVEL.WIZARD]: 100
}


export const BADGE_COORDINATE = {
  NUM_SESSIONS: {
    'PAL': {left: "25.4%", bottom: "24.3%"},
    "BUDDY": {left: "28.1%", bottom: "32.4%"},
    "RANGER": {left: "32.3%", bottom: "37%"},
    "TITAN": {left: "37%", bottom: "35%"},
    "GURU": {left: "41%", bottom: "30%"},
    "WIZARD": {left: "44%", bottom: "21%"},
  },
  NUM_MINUTES: {
    "BUDDY": {left: "24.3%", bottom: "39.9%"},
    "GURU": {left: "45.3%", bottom: "35.9%"},
  },
  NEW_WCPM_HIGH: {
    'PAL': {left: "20.9%", bottom: "27.1%"},
    "BUDDY": {left: "20.7%", bottom: "47.5%"},
    "RANGER": {left: "31.2%", bottom: "48.1%"},
    "TITAN": {left: "39%", bottom: "46%"},
    "GURU": {left: "50%", bottom: "42.3%"},
    "WIZARD": {left: "50.5%", bottom: "23.1%"}
  },
  SKILLS_SCAFFOLD_GRADUATION: {
    'PAL': {left: "16.6%", bottom: "30.1%"},
    "GURU": {left: "54.4%", bottom: "48.7%"},
  },
  NEW_HIGH: {
    "RANGER": {left: "30.1%", bottom: "59.6%"},
    "GURU": {left: "59.1%", bottom: "55.4%"},
    "WIZARD": {left: "57.4%", bottom: "25.3%"},
  },
  CUSTOM: {
    'PAL': {left: "0%", bottom: "41.4%"},
    "BUDDY": {left: "17%", bottom: "57%"},
    "RANGER": {left: "29.3%", bottom:"71%"},
    "TITAN": {left: "42%", bottom: "57%"},
    "GURU": {left: "64%", bottom: "62%"},
    "WIZARD": {left: "64.3%", bottom: "27.5%"}
  },
};

export const BADGE_IMAGE = {
  "PAL": pandaBadgeImage,
  "BUDDY": bearBadgeImage,
  "RANGER": rabbitBadgeImage,
  "TITAN": tigerBadgeImage,
  "GURU": gorillaBadgeImage,
  "WIZARD": unicornBadgeImage
};

export const DANCE_TITLES = {
  CHICKEN: "The Funky Chicken",
  RENEGADE: "The Renegade Dance",
  FLOSS: "The Floss Dance",
};

export const CERT_IMAGE = {
  PAL: certPal,
  BUDDY: certBuddy,
  RANGER: certRanger,
  TITAN: certTitan,
  GURU: certGuru,
  WIZARD: certWizard,
};

export const BW_CERT_IMAGE = {
  PAL: bwCertPal,
  BUDDY: bwCertBuddy,
  RANGER: bwCertRanger,
  TITAN: bwCertTitan,
  GURU: bwCertGuru,
  WIZARD: bwCertWizard,
};

export const BADGE_LEVELS = [
  "PAL",
  "BUDDY",
  "RANGER",
  "TITAN",
  "GURU",
  "WIZARD"
];

export const REWARD_LEVEL_OPTIONS = [
  {value: REWARD_LEVEL.PAL, label: 'Pal Level 1 (Pink Panda)'},
  {value: REWARD_LEVEL.BUDDY, label: 'Buddy Level 2 (Yellow Bear)'},
  {value: REWARD_LEVEL.RANGER, label: 'Ranger Level 3 (Red Rabbit)'},
  {value: REWARD_LEVEL.TITAN, label: 'Titan Level 4 (Teal Tiger)'},
  {value: REWARD_LEVEL.GURU, label: 'Guru Level 5 (Green Gorilla)'},
  {value: REWARD_LEVEL.WIZARD, label: 'Wizard Level 6 (Violet Unicorn)'},
]

export const BACKGROUND_WIDTH = 1920;
export const BACKGROUND_HEIGHT = 1080;